export const MAIN_PERFORMER_TYPE_CODE = 1;

export const YOUNG_PERFORMER_TYPE_CODE = 7;

export const CURRENT_PERFORMER_YP_CODE = 16;

export const CD_TYPE_CODE = 19;

export const CD_USER_TYPE = "CastingDirector";
